import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaTimesCircle } from 'react-icons/fa';
import { BrandLogo } from '../components/BrandLogo';

function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <Link to="/dashboard" className="inline-flex items-center space-x-2 text-emerald-600 hover:text-emerald-700">
            <BrandLogo className="w-9 h-9" testId="payment-cancel-logo" />
            <span className="text-xl font-bold">Legacy Forge Family</span>
          </Link>
        </div>

        {/* Cancel Card */}
        <div className="bg-white rounded-xl shadow-lg p-8 text-center">
          <FaTimesCircle className="text-6xl text-yellow-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Payment Cancelled</h1>
          <p className="text-gray-600 mb-6">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          
          <div className="space-y-3">
            <button
              onClick={() => navigate(-1)}
              className="w-full px-6 py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 font-semibold"
            >
              Try Again
            </button>
            <button
              onClick={() => navigate('/dashboard')}
              className="w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-semibold"
            >
              Return to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancel;
